import ServicePageTemplate from '../ServicePageTemplate';
import { homeFaqs } from '../../../mocks/faqs';

export default function OutdoorLiving() {
  return (
    <ServicePageTemplate
      heroTitle="Outdoor Living Space Design & Build"
      heroSubtitle="Complete outdoor living environments that extend your home's living space with premium hardscape, fire features, and custom design."
      heroImage="https://www.parksidepavers.com/files/projects/14/thumb/thumb_IMG%5F2835%2Dlanding%2Ejpg"
      serviceBreakdownTitle="Our Outdoor Living Services"
      serviceBreakdown={[
        { title: 'Outdoor Kitchen Prep', desc: 'Hardscape foundations and layouts designed for outdoor cooking and entertainment.', icon: 'ri-goblet-line' },
        { title: 'Fire Pit & Fireplace Areas', desc: 'Built-in fire features integrated seamlessly into your patio or outdoor space.', icon: 'ri-fire-line' },
        { title: 'Seating Walls & Benches', desc: 'Built-in seating that defines your outdoor room without additional furniture.', icon: 'ri-sofa-line' },
        { title: 'Custom Entertainment Areas', desc: 'Full-scale outdoor living rooms designed for gathering, relaxing, and entertaining.', icon: 'ri-tv-line' },
      ]}
      aiAnswerText="Outdoor living space design and construction transforms your yard into a fully functional extension of your home. Parkside Pavers designs and installs complete outdoor living environments including patios, seating walls, fire features, and entertainment areas throughout Tampa Bay. Every project is custom-designed around your lifestyle, property layout, and vision for how you want to use your outdoor space."
      aiAnswerBenefits={[
        'Extends your home\'s living area',
        'Increases property value significantly',
        'Custom to your exact vision',
        'Durable materials for Florida weather',
        'Integrated fire & water features',
        'Built for entertaining & relaxation',
      ]}
      faqs={[
        { question: 'How much does an outdoor living space cost?', answer: 'Outdoor living space projects vary widely based on size, features, and material selections. Projects can range from simple patio and seating wall combos to elaborate multi-level entertainment areas. Parkside Pavers provides free on-site estimates tailored to your specific goals.' },
        { question: 'Can you add an outdoor kitchen to a paver patio?', answer: 'Absolutely. Parkside Pavers can design and build the hardscape foundation, layout, and surrounding paving for outdoor kitchen areas. We work with your preferred outdoor kitchen supplier to ensure everything integrates perfectly.' },
        ...homeFaqs.slice(2),
      ]}
      seoCity="Tampa Bay"
    />
  );
}
